require('jquery');
Modernizr = require('modernizr');
require("SimpleBarJs");
require("SimpleBarCss");

require('./app/shading_content.coffee')
require('./app/header.coffee')
require('./app/news_popup.coffee')
require('./app/buttom_to_top.coffee')
require('./app/copy_url_share.coffee')
require('./app/search.coffee')
require('./app/video.coffee')
require('./app/page_resources_helper.coffee')
require('./app/browser_detect.coffee')
require('./app/cookie_notifier.coffee')
require('./app/answers.coffee')

window.pageInitCommonFlag = false

pageInit = ->
  editTitle()
  window.shading = new window.ShadingContent()
  window.shadingContent = [] # содержит массив элементов, которые не затеняются маской
  window.headerObject = new window.Header()
  window.searchObject = new window.Search()
  window.newspopupObject = new window.NewsPopup()
  window.answersObject = new window.Answers()
  new window.ButtonToTop()
  new window.Video()
  new window.PageResourcesHelper()
  window.currentScroll = 0
  window.currentScrollSetFlag = false
  browserDetect = new window.BrowserDetect()
  new window.CookieNotifier()

  if Modernizr.cssgrid
    $('body').removeClass('old-browser-fix-wrapper')
  else
    $('body').addClass('old-browser-fix-wrapper')

  $('.gosbar__notification-list').each ->
    new SimpleBar($(this)[0], { autoHide: false })

  if (browserDetect.browser == "Chrome" && browserDetect.version < 50) ||
  (browserDetect.browser == "Firefox" && browserDetect.version < 40) ||
  (browserDetect.browser == "Explorer" && browserDetect.version < 11) ||
  (browserDetect.browser == "Opera" && browserDetect.version < 37) ||
  (browserDetect.browser == "Safari" && browserDetect.version < 9)
    $(".old-browser").show()
  else
    $(".old-browser").hide()

editTitle = ->
  meta_title = $('h1').html();

  if window.location.pathname == '/'
    document.title = 'Администрация города Юрги'
  else if meta_title && meta_title.length > 0
    document.title = meta_title + ' | Администрация города Юрги'
  else
    document.title = 'Администрация города Юрги'


$(document).ready ->
  if window.pageInitCommonFlag != true
    pageInit()
  window.pageInitCommonFlag = true
  $('html').removeClass('body-overflow')
  $('.b-page').removeClass('b-page--hidden')

  window.headerObject.editHeaderPosition()
  
  $('.js-open-frame-form').click ->
    $('.pos-banner-btn_2').click();
    $('.pos-banner-btn').click();



// WEBPACK FOOTER //
// ./assets/javascripts/common.coffee